import React from 'react';
import { Row, Col } from 'antd';

import ico_mail from '../../../assets/images/sitio/FOOTER/icono_mail.png';

const FloatWsp = () => {
  return (
    <Row className="content_wsp_fixed">
      <Col xs={{span:0, offset:0}} lg={{span:2, offset:21}}>
        <a href="mailto:harinadetrigo@canimolt.org"><img alt="Email" src={ico_mail} className="sticky_wsp" /></a>
      </Col>
    </Row>
  );
}
export default FloatWsp;
